import { createAction, props } from '@ngrx/store';
import { SharedConfigWrapper } from '../../models/app-config/shared-config-wrapper';

export const fetchAppConfigData = createAction('[AppConfig] Fetch AppConfig data');
export const setAppConfigData = createAction(
  '[AppConfig] Set AppConfig data',
  props<{ payload: SharedConfigWrapper }>(),
);

export const httpFail = createAction('[AppConfig] Http fail', props<{ payload: string }>());
